/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Interaction from 'astro/server/interaction';

import HostileAttribute from 'astro/util/attribute/hostile';


export default class extends Interaction
{
  installTargetPlanet (planet)
  {
    const target = planet.getZones().getOne(this.cass.target.id);

    target.getAttributes().installResistance(this.makeResistanceAttribute());
  }


  installSourcePlanet (planet)
  {
    // no-op.
  }


  makeResistanceAttribute ()
  {
    return new HostileAttribute(this.cass.user, 'resistance-interaction', 0.5);
  }


  isAggressive ()
  {
    return true;
  }


};
